import type { Router } from 'vue-router'
import type { MenuRouteDto } from '@/models/auth'
import { getAuthorizedRouteDefinitions } from '@/router/catalog'

let removeRoutes: Array<() => void> = []

export function clearAuthorizedRoutes() {
  for (const removeRoute of removeRoutes) removeRoute()
  removeRoutes = []
}

export function installAuthorizedRoutes(router: Router, menus: MenuRouteDto[]) {
  clearAuthorizedRoutes()
  removeRoutes = getAuthorizedRouteDefinitions(menus).map(({ route }) => router.addRoute('app', route))
}
